export default "__VITE_ASSET__06d059b5__"